import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-387e8a28"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = {
  key: 0,
  class: "view-tenant-review-container"
}
const _hoisted_3 = { class: "review-content" }
const _hoisted_4 = { class: "review-content-history" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title w-100 d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text" }, "Rental History")
], -1))
const _hoisted_6 = {
  key: 0,
  class: "review-content-inner"
}
const _hoisted_7 = { class: "content-tab" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-user d-inline-block icon" }, null, -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Tenant Report ")
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-user d-inline-block icon" }, null, -1))
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Agent Details ")
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navigator = _resolveComponent("Navigator")!
  const _component_Header = _resolveComponent("Header")!
  const _component_History = _resolveComponent("History")!
  const _component_BusinessLogo = _resolveComponent("BusinessLogo")!
  const _component_GoogleMap = _resolveComponent("GoogleMap")!
  const _component_Report = _resolveComponent("Report")!
  const _component_AgentDetails = _resolveComponent("AgentDetails")!
  const _component_NoReview = _resolveComponent("NoReview")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Navigator, { text: "Back to dashboard" }),
    (_ctx.tenantReviews.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_Header, {
            tenant: _ctx.tenantRecord,
            averageRating: _ctx.averageRating,
            tenantReviews: _ctx.tenantReviews
          }, null, 8, ["tenant", "averageRating", "tenantReviews"]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_History, {
                tenantReview: _ctx.tenantReview,
                tenantReviews: _ctx.tenantReviews,
                currentTenantReview: _ctx.currentTenantReview,
                loading: _ctx.loading,
                onSelectRentalHistory: _ctx.handleSelectRentalHistory
              }, null, 8, ["tenantReview", "tenantReviews", "currentTenantReview", "loading", "onSelectRentalHistory"])
            ]),
            (_ctx.currentTenantReview)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", {
                    class: "title w-100 d-flex align-items-center justify-content-center",
                    style: _normalizeStyle(`background:${_ctx.headerColor}!important`)
                  }, [
                    (_ctx.hasLogo)
                      ? (_openBlock(), _createBlock(_component_BusinessLogo, {
                          key: 0,
                          imageSrc: _ctx.getBusinessLogo,
                          fill: "scale-down",
                          height: "28px"
                        }, null, 8, ["imageSrc"]))
                      : _createCommentVNode("", true)
                  ], 4),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["content-tab-item", { active: _ctx.tab == 'report' }]),
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.tab = 'report'))
                    }, _hoisted_10, 2),
                    _createElementVNode("div", {
                      class: _normalizeClass(["content-tab-item", { active: _ctx.tab == 'details' }]),
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.tab = 'details'))
                    }, _hoisted_13, 2)
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["map", { 'd-none': _ctx.tab != 'report', 'd-block': _ctx.tab == 'report' }])
                  }, [
                    _createVNode(_component_GoogleMap, {
                      disableUI: false,
                      zoom: 14,
                      mapType: "roadmap",
                      center: { lat: -33.867, lng: 151.195 },
                      draggable: false,
                      query: _ctx.currentAddress,
                      ref: "googleMap"
                    }, null, 8, ["center", "query"])
                  ], 2),
                  (_ctx.tab == 'report')
                    ? (_openBlock(), _createBlock(_component_Report, {
                        key: 0,
                        tenantReviews: _ctx.tenantReviews,
                        reviewDetailLoading: _ctx.reviewDetailLoading,
                        currentTenantReview: _ctx.currentTenantReview,
                        "average-rating": _ctx.averageRating
                      }, null, 8, ["tenantReviews", "reviewDetailLoading", "currentTenantReview", "average-rating"]))
                    : _createCommentVNode("", true),
                  (_ctx.tab == 'details')
                    ? (_openBlock(), _createBlock(_component_AgentDetails, {
                        key: 1,
                        currentTenantReview: _ctx.currentTenantReview
                      }, null, 8, ["currentTenantReview"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : (_openBlock(), _createBlock(_component_NoReview, {
          key: 1,
          tenant: _ctx.tenant
        }, null, 8, ["tenant"]))
  ]))
}